import TABLE_DATA_KEYS from "@/components/base_components/tables/enum/table-data-keys";
import FILTER_CARD_STATES from "@/components/base_components/tables/filter/FILTER_CARD_STATES";

export default {
  generateTableIdentifier(concept, state) {

    const generateTableIdentifier = ((concept) => {
      let number = 0;
      return () => {
        ++number;
        return `${concept}_${number}`;
      }
    })(concept);

    let tableIdentifier = generateTableIdentifier();
    while (isIdentifierAlreadyTaken(tableIdentifier, state) === true) {
      tableIdentifier = generateTableIdentifier();
    }
    return tableIdentifier;
  },

  generateTableObject(table) {
    return getDefaultFilterAndTableWrapperFor(table);
  },

  generateSubTableObject(subTable) {
    return getDefaultSubTableObjectFor(subTable);
  },

  flattenTable(table, subTableIdentifier) {
    const tableData = table.subTables[subTableIdentifier];
    const result = {};

    for (const key in table) {
      if (key !== 'subTables') {
        result[key] = table[key];
      }
    }

    if (tableData)
      Object.assign(result, tableData);

    return result;
  }

}

const isIdentifierAlreadyTaken = (tableIdentifier, state) => {
  return state?.tables?.[tableIdentifier] !== undefined;
}

const getDefaultFilterAndTableWrapperFor = (table) => {
  const HANDED_SEARCH_EXPRESSION = table?.[TABLE_DATA_KEYS.SEARCH_EXPRESSION];
  const DEFAULT_CARD_STATE = FILTER_CARD_STATES.SELECT;

  return {
    [TABLE_DATA_KEYS.SEARCH_EXPRESSION]: HANDED_SEARCH_EXPRESSION ?? "",
    [TABLE_DATA_KEYS.FILTER_CARD_STATE]: DEFAULT_CARD_STATE,
    [TABLE_DATA_KEYS.FILTERS]: table[TABLE_DATA_KEYS.FILTERS] ?? {},
    [TABLE_DATA_KEYS.FILTER_ORDER]: table[TABLE_DATA_KEYS.FILTER_ORDER] ?? [],
    [TABLE_DATA_KEYS.NOT_VISIBLE_FILTERS]: table[TABLE_DATA_KEYS.NOT_VISIBLE_FILTERS] ?? undefined, //set to "undefined" instead of "[]" to allow for default invisible Filters
    [TABLE_DATA_KEYS.PRESET]: {},
    subTables: {}
  }
}

const getDefaultSubTableObjectFor = (table) => {
  return {
    [TABLE_DATA_KEYS.SORT_BY]: table[TABLE_DATA_KEYS.SORT_BY] ?? [],
    [TABLE_DATA_KEYS.SORT_BY_DESC]: table[TABLE_DATA_KEYS.SORT_BY_DESC] ?? [],
    [TABLE_DATA_KEYS.HEADERS]: table[TABLE_DATA_KEYS.HEADERS] ?? [],
    [TABLE_DATA_KEYS.HEADER_ORDER]: table[TABLE_DATA_KEYS.HEADER_ORDER] ?? [],
    [TABLE_DATA_KEYS.NOT_VISIBLE_HEADERS]: table[TABLE_DATA_KEYS.NOT_VISIBLE_HEADERS] ?? [],
    [TABLE_DATA_KEYS.TRUNCATE_DATA]: table[TABLE_DATA_KEYS.TRUNCATE_DATA] ?? true,
    [TABLE_DATA_KEYS.TRUNCATE_OPTIONS]: table[TABLE_DATA_KEYS.TRUNCATE_OPTIONS] ?? {},
  }
}
